export default "__VITE_ASSET__DY0Em6ob__"